import "@blocknote/mantine/style.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { isStatus } from "./lib/api";
import { ThemeProvider } from "./lib/theme";
import { FeedbackProvider } from "./components/ui/feedback";
import { router } from "./router";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5_000,
      retry: (count, err) => !isStatus(err, 401) && !isStatus(err, 403) && !isStatus(err, 404) && count < 2,
      refetchIntervalInBackground: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <FeedbackProvider>
          <RouterProvider router={router} />
        </FeedbackProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>,
);
